import css from './simpleTile.module.scss';

import { memo } from 'react';

import { LANGUAGES_DATA } from 'core/helpers/languages';
import { getNumbersUrl } from 'core/paths';
import Button from 'core/ui/Button';
import LangIcon from 'core/ui/LangIcon';

const NumbersTile = ({ lang }: { lang: TLang }) => (
  <div className={css.simpleTile}>
    <LangIcon className={css.simpleTileIcon} lang={lang} />
    <span className={css.simpleTileLabel}>
      {LANGUAGES_DATA[lang].nativeName} numbers
    </span>
    <Button className={css.simpleTileButton} link={getNumbersUrl(lang)}>
      Open
    </Button>
  </div>
);

export default memo(NumbersTile);
